module.exports = __webpack_public_path__ + "img/app-phone-2.6f3779a.svg";